module.exports = __webpack_public_path__ + "static/eleksyonph-dcbf0df835b109ee6f59fb8167abe433.jpg";